import { createBrowserRouter } from "react-router-dom";
//import Home from "./screens/home/home";
import Login from "./screens/login/login";
import NotFound from "./notFound";
import MobileList from "./screens/mobileList/mobileList";
import DetectList from "./screens/detectList/detectList";
import Notice from "./screens/notice/notice";
import Stastics from "./screens/stastics/stastics";
import Control from "./screens/control/control";
import WriteNotice from "./screens/notice/writeNotice";
import NoticeDetail from "./screens/notice/noticeDetail";
import ManageUser from "./screens/manageUser/manageUser";
import ManageCustomer from "./screens/manageCustomer/manageCustomer";
import ManageNok from "./screens/manageNok/manageNok";
//import ControlPast from "./screens/controlPast/controlPast";
import WithAuth from "./WithAuth";
import WithDetect from "./WithDetect";
import { ProtectedRoute } from "./screens/protectedRoute";
import App from "./App";
import { Sitemap } from "./screens/sitemap/Sitemap";
const id = process.env.REACT_APP_ROUTE_ID ?? ``;

const router = createBrowserRouter(
  [
    {
      path: `/`,
      element: (
        <WithAuth>
          <WithDetect>
            <App />
          </WithDetect>
        </WithAuth>
      ),
      errorElement: <NotFound />,
      children: [
        { index: true, path: `/`,element: <Control />/*<Home />*/ },
        { path: `*`, element: <NotFound /> },
        { path: `login`, element: <Login /> },
        { path: `mobile-list`, element: <MobileList /> },
        { path: `detect-list`, element: <DetectList /> },
        { path: `notice`, element: <Notice /> },
        { path: `notice/pages/:pages`, element: <Notice /> },
        { path: `notice/:id`, element: <NoticeDetail /> },
        { path: `notice-admin`, element: <WriteNotice /> },
        { path: `stastics`, element: <Stastics /> },
        { path: `/:id`/*`${id}/control/:id`*/, element: <Control /> },
        //{ path: `control`, element: <Control /> },
        //{ path: `control/past`, element: <ControlPast /> },
        {
          path: `admin`,
          element: (
            <ProtectedRoute require>
              <ManageUser />
            </ProtectedRoute>
          ),
        },
        { path: `customer`, element: <ManageCustomer /> },
        { path: `nok`, element: <ManageNok /> },
        { path: `sitemap`, element: <Sitemap /> },
        // 점검중 페이지 비활성화 - 2025-01-20
        // {
        //   path: `maintenance`,
        //   element: (
        //     <ProtectedRoute require>
        //       <Maintenance />
        //     </ProtectedRoute>
        //   ),
        // },
      ],
    },
  ],
  {
    basename: `${id}`,
  }
);
export default router;
